/**
 * Login/CreateAccount Controller
 *
 * 
 */

// the constructor for this object
function LoginCreateAccountController() { }

// the object
LoginCreateAccountController.prototype = {
    constructor: LoginCreateAccountController,
    
    // the customer account ID the user will be added to
    accountId: '',
    
    // the email address that we extracted from the URL
    emailAddr: '',
    
    /*
        A SHA256 hash we extracted from the URL. This is used to verify the 
        request to the API
    */
    verificationHash: '',
    
    // the first name of the user from the URL 
    firstNm: null,
    
    // the last name of the user from the URL
    lastNm: null,
    
    // initialize the controller
    init: function() 
    {
        // register the route variables used by this controller
        this._registerRouteVariables();
    
        PortalHelper.debugMessage('Create Account Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        // get the active legal agreements
        this._getLegalAgreements();
        
        PortalHelper.debugMessage('Create Account Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the controller parameters
        this.accountId = segments[0] == null ? null : segments[0];
        this.verificationHash = segments[1] == null ? null : segments[1];
        this.emailAddr = segments[2] == null ? null : decodeURIComponent(segments[2]);
        this.firstNm = segments[3] == null ? null : decodeURIComponent(segments[3]);
        this.lastNm = segments[4] == null ? null : decodeURIComponent(segments[4]);
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {
        var self = this;
        $('#create-acct-form').on('submit', function(e) {
            e.preventDefault();
            
            if($('#create-acct-form').parsley().validate()) {
                self._createUser();
            }
        });
    },
    
    // get the agreements from the api
    _getLegalAgreements: function()
    {
        var agreementsRequest = new PortalRequest;
        agreementsRequest.makeRequest(
            '/legal/get-active-agreements',
            {},
            function(response) {
               PortalMain.LoginCreateAccountController._populateAgreements(response);
               
               PortalMain.LoginCreateAccountController._setupForm();
            }
        )
    },
    
    // fill in the agreements
    _populateAgreements: function(agreements)
    {
        var linkString = '';
        var legalCount = agreements.length;
        for (var i in agreements) {
            var agreement = agreements[i];
            var legalUrl = PortalConfig.portalUrl + '/legal/view/' + agreement.legal_agreement_id;
            linkString += '<a href="' + legalUrl + '" target="_blank">';
            linkString += agreement.title;
            linkString += '</a>';
            
            if (i == legalCount - 2) {
                linkString += ' and ';
            } else if (i < legalCount - 2) {
                linkString += ', ';
            }
        }
        
        $('#legal-links').html(linkString);
    },
    
    // Populates the fields on the form
    _setupForm: function()
    {
        $('#email').val(this.emailAddr);
        
        if (this.firstNm != null) {
            $('#first-name').val(this.firstNm);
        }
    
        if (this.lastNm != null) {
            $('#last-name').val(this.lastNm);
        }
        
        // show the account and invoice number fields
        if (this.verificationHash == null) {
            $('#account-number-field').removeClass('hidden');
            $('#invoice-number-field').removeClass('hidden');
        } else {
            $('#account-number').prop('required', false);
            $('#account-number').removeAttr('required');
            $('#invoice-number').prop('required', false);
            $('#invoice-number').removeAttr('required');
        }
        
        
        // turn on the submit button
        PortalHelper.enableButton('#create-button');
        $('.form').removeClass('loading');
    },
    
    // call the API to create a portal user
    _createUser: function()
    {
        // store these variables to log in after creation
        var email = $('#create-acct-form #email').val();
        var password = $('#create-acct-form #password').val();
        
        // build the data to be submitted
        var submissionData = {
            email_nm: $('#create-acct-form #email').val(),
            first_nm: $('#create-acct-form #first-name').val(),
            last_nm: $('#create-acct-form #last-name').val(),
            passwd: $('#create-acct-form #password').val(),
            confirm: $('#create-acct-form #confirm').val(),
            legal_agree: $('#create-acct-form #legal-agree:checked').val(),
            g_recaptcha_response: grecaptcha.getResponse(),
        };
        
        // apply the route specific variables
        if (this.verificationHash == null) {
            var route = '/users/create-user-from-invoice';
            submissionData.account_number = $('#create-acct-form #account-number').val();
            submissionData.invoice_number = $('#create-acct-form #invoice-number').val();
        } else {
            var route = '/users/create-user-from-hash';
            submissionData.hash = this.verificationHash;
            submissionData.account_id = this.accountId;
        }
        
        // make the request
        var createUserRequest = new PortalRequest;
        createUserRequest.errorElement = '.form-errors';
        createUserRequest.successElement = '.form-success';
        createUserRequest.makeRequest(
            route,
            submissionData,
            function(response, responseCode) {
                
                // if the user was created through a verification hash, log them in
                if (responseCode == 'USER_CREATED') {
                    PortalMain.LoginCreateAccountController.getToken(email, password);
                }
            }
        )
    },
    
    // get the tickets and data and populate the list
    getToken: function(email, password) 
    {    
        var tokenRequest = new PortalRequest;
        tokenRequest.storeToken = true;
        tokenRequest.errorElement = '#create-acct-form .form-errors';
        tokenRequest.successElement = '#create-acct-form .form-success';
        tokenRequest.makeRequest(
            '/auth/get-token',
            {
                email: email,
                password: password
            },
            function(data, code, message) {
                PortalMain.LoginIndexController = new LoginIndexController();
                PortalMain.LoginIndexController.loginComplete();
                $('.form-success').append('<br> Redirecting...');
            }
        );
    },
    
}